import { crudMdActions } from "@/services/crud-md-actions";

const name = "users";

export default {
  name,
  ...crudMdActions(name),
};
